import UtilityService from "../services/UtillityServices/UtilityService";

const useArchivioRendicontazioniConfigTable = () => {
    return [
        {
            key: 'data_liquidazione',
            label: 'Data Liquidazione',
            formatter: (value) => UtilityService.formatDate(value),
        },
        {
            key: 'nome_agenzia',
            label: 'Agenzia',
        },
        {
            key: 'periodo',
            label: 'Periodo',
            formatter: (value, row) => `${row.mese}/${row.anno}`,
        },
        {
            key: 'totale_provvigioni',
            label: 'Totale Liquidato',
            formatter: (value) => `€ ${parseFloat(value).toFixed(2)}`,
            className: 'text-end'
        },
        {
            key: 'documenti',
            label: 'Documenti',
            formatter: (value, row) => (
                // Aggiungiamo 'align-items-center' per centrare verticalmente
                <div className="d-flex justify-content-center align-items-center gap-2 h-100">
                    <a href={row.path_fattura} target="_blank" rel="noopener noreferrer" className="btn btn-outline-info btn-sm" title="Visualizza Fattura">
                        <i className="bi bi-file-earmark-text-fill fs-5"></i>
                    </a>
                    <a href={row.path_ricevuta_pagamento} target="_blank" rel="noopener noreferrer" className="btn btn-outline-success btn-sm" title="Visualizza Ricevuta Pagamento">
                        <i className="bi bi-file-earmark-check-fill fs-5"></i>
                    </a>
                </div>
            ),
            className: 'text-center' // L'allineamento è gestito dal div interno
        }
    ];
};

export default useArchivioRendicontazioniConfigTable;